module.exports = __webpack_public_path__ + "static/media/eco_pay_tokens.0b470eb8.png";